<div [formGroup]="profileForm" class="flex items-center justify-between ">
  <label class="text-gray-400 w-2/5">{{item.title}}</label>
  <input (blur)="blurEvent.emit($event)" [formControlName]="item.formControlName" [placeholder]="item.placeholder ?? item.title" [ngClass]="class"
    class="border rounded-full border-gray-200 text-gray-700 focus:outline-none w-3/5 focus:ring-1 focus:ring-gray-300 focus:border-gray-300" />
</div>